import { Box, Typography } from "@mui/material";
import SubmitButton from "../../../UI/SubmitButton";
import EntryButton from "../../../UI/EntryButton";
import { useDispatch, useSelector } from "react-redux";
import { setModal } from "../../../store/modalSlice";
import { useTranslation } from "react-i18next";
import { warhouseUpdateAction } from "../../../asyncActions/warhouseActions";

function WarehouseDocumentContent({ type }) {
    const { t } = useTranslation()

    const dispatch = useDispatch()

    const {
        data
    } = useSelector(store => store.modal)

    const submitHandle = () => {
        const modalPayload = {
            active: true,
            content: 'action',
            data: {
                text: 'Done!'
            }
        }
        dispatch(warhouseUpdateAction(data.payload))
        dispatch(setModal(modalPayload))
    }

    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '25px',
            width: '450px'
        }}>
            <Typography variant="h6">Confirm inventorization</Typography>
            <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between' }}>
                <EntryButton onClick={() => dispatch(setModal({ active: false }))}>{t('button.cancel')}</EntryButton>
                <SubmitButton onClick={submitHandle}>{t('button.submit')}</SubmitButton>
            </Box>
        </Box>
    )
}


export default WarehouseDocumentContent
